export const ASSIGNABLE_TEAM_ROLES = [
  { value: 'ADMIN', label: 'Admin' },
  { value: 'MANAGER', label: 'Manager' },
  { value: 'CREATOR', label: 'Creator' },
  { value: 'MEMBER', label: 'Member' },
  { value: 'VIEWER', label: 'Viewer' },
];

export function isPlatformAdmin(profile) {
  return Boolean(profile?.roles?.includes('ROLE_ADMIN'));
}

export function canManageTeamMemberRoles(orgDetail, profile) {
  if (isPlatformAdmin(profile)) return true;
  if (!orgDetail) return false;
  if (orgDetail.canManageMemberRoles === true) return true;
  const role = (orgDetail.role || '').toUpperCase();
  return Boolean(orgDetail.isOwner) || role === 'OWNER' || role === 'ADMIN' || role === 'MANAGER';
}

export function memberRoleSelectValue(member) {
  if (member?.isOwner) return 'OWNER';
  const r = (member?.role || 'MEMBER').toUpperCase();
  return ASSIGNABLE_TEAM_ROLES.some((o) => o.value === r) ? r : 'MEMBER';
}
